module.exports = "/dist/116c4c4b14ef76b0555da09854512022.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200italic.woff2
// module id = 115
// module chunks = 0